<template>
  <div class="w-full">
    <component :is="activeIsolationMod" :isolationKeys="isolationKeys" :centers="centers" :editObj="editObj"/>
  </div>

</template>

<script>
  import IsolationContent from "./IsolationContent";
  import firebase from "firebase";
  import {db} from '@/db'
  import {eventBus} from "../../eventbus";
  import IsolationAdd from "./IsolationAdd";
  import IsolationEdit from "./IsolationEdit";

  export default {
    name: "IsolationIndex",
    components: {
      IsolationContent,
      IsolationAdd,
      IsolationEdit
    },
    data: () => ({
      isolationKeys: [],
      centers: [],
      editObj: {},
      activeIsolationMod: 'IsolationContent'
    }),
    firebase: {
      centers: db.ref('isolation_centre').orderByChild('area'),
    },
    watch: {
      centers() {
        this.getKeys()
      }
    },
    methods: {
      getKeys() {
        let keys = []
        firebase.database().ref('isolation_centre/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.isolationKeys = keys
      },
      listener(){
        eventBus.$on('AddCenter', ()=> this.activeIsolationMod = 'IsolationAdd')
        eventBus.$on('AllCenter', ()=> this.activeIsolationMod = 'IsolationContent')
        eventBus.$on('EditCenter', (x)=> {
          this.editObj = x;
          this.activeIsolationMod = 'IsolationEdit'

        })
      }
    },
    created() {
      this.listener()
    }
  }
</script>

<style scoped>

</style>